<template>
  <meta name="viewport" content="initial-scale=1, viewport-fit=cover" />
  <NuxtLayout id="layoutTopCompo" class="flex flex-col items-center">
    <NuxtPage />
  </NuxtLayout>
  <AgendaSnackbar
    :action="snackbarStore.action"
    :close="snackbarStore.close"
    :message="snackbarStore.message"
    :open="snackbarStore.open"
    :error="snackbarStore.type === snackbar.TYPE_ERROR"
    @close="snackbar.onClose()"
    @action="snackbar.onAction()"
  />
</template>

<script setup>
const snackbar = useSnackbar();
const snackbarStore = useSnackbarStore();
</script>

<style>
body {
  padding: env(safe-area-inset-top) env(safe-area-inset-right)
    env(safe-area-inset-bottom) env(safe-area-inset-left);
}
</style>
